// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Page Wrapper ─────────────────────────────────────────── */
.sd-page {
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  background: #ffffff;
  padding: 16px;
  gap: 16px;
  box-sizing: border-box;
  color: #020617;
  font-family:
    "Inter",
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    Roboto,
    Helvetica,
    Arial,
    sans-serif;
  -webkit-font-smoothing: antialiased;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

@media (min-width: 1024px) {
  .sd-page {
    padding: 20px;
    gap: 20px;
  }
}

/* ── Header card (header only) ─────────────────────────────── */
.sd-header-card {
  background: #ffffff;
  border-radius: 24px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 2px 12px rgba(15, 23, 42, 0.06);
  flex-shrink: 0;
}

/* ── Header ────────────────────────────────────────────────── */
.sd-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 24px;
  box-sizing: border-box;
}

@media (min-width: 1024px) {
  .sd-header {
    padding-left: 32px;
    padding-right: 32px;
  }
}

.sd-header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

/* ── Back Button ───────────────────────────────────────────── */
.sd-back-btn {
  display: flex;
  height: 40px;
  width: 40px;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  border: 1px solid #e2e8f0;
  background-color: #ffffff;
  color: #64748b;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  padding: 0;
}

.sd-back-btn:hover {
  background-color: #f8fafc;
  color: #0f172a;
}

.sd-back-icon {
  height: 20px;
  width: 20px;
}

/* ── Logo ──────────────────────────────────────────────────── */
.sd-logo {
  height: 28px;
  width: auto;
  object-fit: contain;
}

@media (min-width: 1024px) {
  .sd-logo {
    height: 32px;
  }
}

/* ── Step Badge ────────────────────────────────────────────── */
.sd-step-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border-radius: 9999px;
  border: 1px solid #dbeafe;
  background-color: #eff6ff;
  padding: 4px 12px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  color: #2a71ff;
}

/* ── Body Container ────────────────────────────────────────── */
.sd-body {
  display: flex;
  min-height: 0;
  flex: 1;
  flex-direction: column;
  padding: 8px 0;
  overflow-y: auto;
  box-sizing: border-box;
  width: 100%;
  scrollbar-width: thin;
  scrollbar-color: rgba(100, 116, 139, 0.4) transparent;
}

.sd-body::-webkit-scrollbar { width: 4px; }
.sd-body::-webkit-scrollbar-track { background: transparent; }
.sd-body::-webkit-scrollbar-thumb { background-color: rgba(100, 116, 139, 0.4); border-radius: 9999px; }
.sd-body::-webkit-scrollbar-thumb:hover { background-color: rgba(71, 85, 105, 0.7); }

@media (min-width: 1024px) {
  .sd-body {
    padding: 8px 0;
  }
}

.sd-content-wrapper {
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  max-width: 1200px;
  box-sizing: border-box;
  padding: 0 4px;
}

/* ── Top Bar & Breadcrumbs (flat, no card) ─────────────────── */
.sd-top-bar {
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 4px 2px;
  box-sizing: border-box;
}

@media (min-width: 640px) {
  .sd-top-bar {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
}

.sd-title {
  font-size: 22px;
  font-weight: 900;
  letter-spacing: -0.025em;
  color: #020617;
  margin: 0;
}

@media (min-width: 1024px) {
  .sd-title { font-size: 1.75rem; }
}

.sd-breadcrumbs {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.sd-crumb {
  border-radius: 9999px;
  padding: 5px 14px;
  font-size: 13px;
  font-weight: 700;
}

.sd-crumb.loc {
  border: 1px solid #dbeafe;
  background-color: rgba(239, 246, 255, 0.7);
  color: #2563eb;
}

.sd-crumb.org {
  border: 1px solid #d1fae5;
  background-color: rgba(240, 253, 244, 0.7);
  color: #059669;
}

.sd-crumb.type {
  border: 1px solid #ede9fe;
  background-color: rgba(245, 243, 255, 0.7);
  color: #7c3aed;
}

.sd-crumb.channel {
  color: #92400e;
  background: rgba(254, 243, 199, 0.7);
  border: 1px solid #fde68a;
}

/* ── Section Panel ─────────────────────────────────────────── */
.sd-section {
  display: flex;
  flex-direction: column;
}

.sd-section-header {
  margin-bottom: 16px;
}

.sd-section-title {
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #020617;
  margin: 0;
}

.sd-section-desc {
  margin-top: 4px;
  font-size: 13px;
  color: #64748b;
  margin-bottom: 0;
}

/* ── Grid of Terminals ─────────────────────────────────────── */
.sd-term-grid {
  display: grid;
  gap: 14px;
  grid-template-columns: 1fr;
  width: 100%;
}

@media (min-width: 640px) {
  .sd-term-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}

@media (min-width: 1024px) {
  .sd-term-grid { grid-template-columns: repeat(3, minmax(0, 1fr)); }
}

/* ── Terminal Card — base ──────────────────────────────────── */
.sd-term-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  border-radius: 22px;
  border: 1.5px solid #e2e8f0;
  padding: 20px;
  text-align: left;
  transition: all 0.2s ease-in-out;
  box-sizing: border-box;
  width: 100%;
  font-family: inherit;
}

/* ── Available — clean white, green badge ──────────────────── */
.sd-term-card.available {
  cursor: pointer;
  background: #ffffff;
  border-color: #e2e8f0;
}

.sd-term-card.available:hover,
.sd-term-card.available.sd-kb-focused {
  border-color: #2a71ff;
  background: linear-gradient(145deg, #f0f5ff 0%, #ffffff 100%);
  box-shadow: 0 12px 32px rgba(42, 113, 255, 0.14);
}

.sd-term-card.available:hover .sd-term-name,
.sd-term-card.available.sd-kb-focused .sd-term-name {
  color: #2a71ff;
}

.sd-term-card.available:hover .sd-term-check-container,
.sd-term-card.available.sd-kb-focused .sd-term-check-container {
  background-color: #2a71ff;
  color: #ffffff;
}

.sd-term-card.sd-kb-focused {
  outline: 2px solid #2a71ff;
  outline-offset: 2px;
}

/* ── Live — amber/occupied tint ────────────────────────────── */
.sd-term-card.live {
  cursor: not-allowed;
  background: linear-gradient(145deg, #fffbeb 0%, #fef9ee 100%);
  border-color: #fcd34d;
}

.sd-term-card.live .sd-term-icon {
  background: #78350f;
}

.sd-term-card.live .sd-term-check-container {
  background: #fef3c7;
  color: #d97706;
}

.sd-term-card.live .sd-term-name {
  color: #92400e;
}

/* ── Card internals ────────────────────────────────────────── */
.sd-term-top {
  display: flex;
  width: 100%;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.sd-term-icon {
  display: flex;
  height: 48px;
  width: 48px;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
  background-color: #0b132b;
  color: #ffffff;
}

.sd-term-monitor-icon {
  height: 20px;
  width: 20px;
}

.sd-term-check-container {
  display: flex;
  height: 28px;
  width: 28px;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  background-color: #f1f5f9;
  color: #94a3b8;
  transition: background-color 0.2s, color 0.2s;
}

.sd-term-check-icon {
  height: 16px;
  width: 16px;
}

.sd-term-details {
  width: 100%;
  margin-top: 8px;
}

.sd-term-name {
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #020617;
  margin: 0;
  transition: color 0.2s;
}

.sd-term-badge-wrapper {
  margin-top: 14px;
}

/* ── Status badges ─────────────────────────────────────────── */
.sd-status-badge {
  display: inline-flex;
  border-radius: 9999px;
  padding: 4px 12px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.16em;
}

/* Available — green */
.sd-status-badge.available {
  background: #dcfce7;
  color: #16a34a;
  border: 1px solid #bbf7d0;
}

/* Live — amber */
.sd-status-badge.live {
  background: #fef3c7;
  color: #b45309;
  border: 1px solid #fde68a;
}

/* ── No Active Day ─────────────────────────────────────────── */
.sd-section-no-day {
  border-radius: 24px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  padding: 32px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.04);
  max-width: 560px;
  margin: 32px auto;
  text-align: center;
  box-sizing: border-box;
}

.sd-section-no-day .sd-section-header {
  margin-bottom: 12px;
  display: flex;
  justify-content: center;
}

.sd-section-no-day .sd-start-day-btn {
  margin: 20px auto 0 auto;
}

/* ── Loading / Empty ───────────────────────────────────────── */
.sd-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 0;
  width: 100%;
}

.sd-empty-desc {
  font-size: 14px;
  color: #64748b;
  margin: 0;
}

/* ── Start Day Button ──────────────────────────────────────── */
.sd-start-day-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 48px;
  padding: 0 28px;
  background: #2a71ff;
  border: none;
  border-radius: 30px;
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  box-shadow: 0 4px 14px rgba(42, 113, 255, 0.22);
}

.sd-start-day-btn:hover:not(:disabled) {
  background: #1e5ade;
  box-shadow: 0 6px 18px rgba(42, 113, 255, 0.32);
}

.sd-start-day-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  box-shadow: none;
}

.sd-section-tag {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.14em;
  color: #64748b;
  margin: 0 0 4px 0;
  text-transform: uppercase;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/sessionPage/components/startDay.js/indexV2.css"],"names":[],"mappings":"AAAA,gEAAgE;AAChE;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,cAAc;EACd;;;;;;;;cAQY;EACZ,mCAAmC;EACnC,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE;IACE,aAAa;IACb,SAAS;EACX;AACF;;AAEA,iEAAiE;AACjE;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,6CAA6C;EAC7C,cAAc;AAChB;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA,iEAAiE;AACjE;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA,iEAAiE;AACjE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,qBAAqB;EACrB,qDAAqD;AACvD;;AAEA,8BAA8B,UAAU,EAAE;AAC1C,oCAAoC,uBAAuB,EAAE;AAC7D,oCAAoC,0CAA0C,EAAE,qBAAqB,EAAE;AACvG,0CAA0C,wCAAwC,EAAE;;AAEpF;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA,iEAAiE;AACjE;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE;IACE,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;EAChC;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,YAAY,kBAAkB,EAAE;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,SAAS;EACT,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,gBAAgB,gDAAgD,EAAE;AACpE;;AAEA;EACE,gBAAgB,gDAAgD,EAAE;AACpE;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;EACb,gBAAgB;EAChB,gCAAgC;EAChC,sBAAsB;EACtB,WAAW;EACX,oBAAoB;AACtB;;AAEA,iEAAiE;AACjE;EACE,eAAe;EACf,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;EACrB,6DAA6D;EAC7D,gDAAgD;AAClD;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,iEAAiE;AACjE;EACE,mBAAmB;EACnB,6DAA6D;EAC7D,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,iEAAiE;AACjE;EACE,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,iEAAiE;AACjE;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;AAC3B","sourcesContent":["/* ── Page Wrapper ─────────────────────────────────────────── */\n.sd-page {\n  height: 100vh;\n  width: 100vw;\n  overflow: hidden;\n  background: #ffffff;\n  padding: 16px;\n  gap: 16px;\n  box-sizing: border-box;\n  color: #020617;\n  font-family:\n    \"Inter\",\n    -apple-system,\n    BlinkMacSystemFont,\n    \"Segoe UI\",\n    Roboto,\n    Helvetica,\n    Arial,\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n}\n\n@media (min-width: 1024px) {\n  .sd-page {\n    padding: 20px;\n    gap: 20px;\n  }\n}\n\n/* ── Header card (header only) ─────────────────────────────── */\n.sd-header-card {\n  background: #ffffff;\n  border-radius: 24px;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 2px 12px rgba(15, 23, 42, 0.06);\n  flex-shrink: 0;\n}\n\n/* ── Header ────────────────────────────────────────────────── */\n.sd-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 24px;\n  box-sizing: border-box;\n}\n\n@media (min-width: 1024px) {\n  .sd-header {\n    padding-left: 32px;\n    padding-right: 32px;\n  }\n}\n\n.sd-header-left {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n/* ── Back Button ───────────────────────────────────────────── */\n.sd-back-btn {\n  display: flex;\n  height: 40px;\n  width: 40px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 9999px;\n  border: 1px solid #e2e8f0;\n  background-color: #ffffff;\n  color: #64748b;\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n  padding: 0;\n}\n\n.sd-back-btn:hover {\n  background-color: #f8fafc;\n  color: #0f172a;\n}\n\n.sd-back-icon {\n  height: 20px;\n  width: 20px;\n}\n\n/* ── Logo ──────────────────────────────────────────────────── */\n.sd-logo {\n  height: 28px;\n  width: auto;\n  object-fit: contain;\n}\n\n@media (min-width: 1024px) {\n  .sd-logo {\n    height: 32px;\n  }\n}\n\n/* ── Step Badge ────────────────────────────────────────────── */\n.sd-step-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  border-radius: 9999px;\n  border: 1px solid #dbeafe;\n  background-color: #eff6ff;\n  padding: 4px 12px;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.18em;\n  color: #2a71ff;\n}\n\n/* ── Body Container ────────────────────────────────────────── */\n.sd-body {\n  display: flex;\n  min-height: 0;\n  flex: 1;\n  flex-direction: column;\n  padding: 8px 0;\n  overflow-y: auto;\n  box-sizing: border-box;\n  width: 100%;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(100, 116, 139, 0.4) transparent;\n}\n\n.sd-body::-webkit-scrollbar { width: 4px; }\n.sd-body::-webkit-scrollbar-track { background: transparent; }\n.sd-body::-webkit-scrollbar-thumb { background-color: rgba(100, 116, 139, 0.4); border-radius: 9999px; }\n.sd-body::-webkit-scrollbar-thumb:hover { background-color: rgba(71, 85, 105, 0.7); }\n\n@media (min-width: 1024px) {\n  .sd-body {\n    padding: 8px 0;\n  }\n}\n\n.sd-content-wrapper {\n  margin-left: auto;\n  margin-right: auto;\n  width: 100%;\n  max-width: 1200px;\n  box-sizing: border-box;\n  padding: 0 4px;\n}\n\n/* ── Top Bar & Breadcrumbs (flat, no card) ─────────────────── */\n.sd-top-bar {\n  margin-bottom: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 4px 2px;\n  box-sizing: border-box;\n}\n\n@media (min-width: 640px) {\n  .sd-top-bar {\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n  }\n}\n\n.sd-title {\n  font-size: 22px;\n  font-weight: 900;\n  letter-spacing: -0.025em;\n  color: #020617;\n  margin: 0;\n}\n\n@media (min-width: 1024px) {\n  .sd-title { font-size: 1.75rem; }\n}\n\n.sd-breadcrumbs {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n}\n\n.sd-crumb {\n  border-radius: 9999px;\n  padding: 5px 14px;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.sd-crumb.loc {\n  border: 1px solid #dbeafe;\n  background-color: rgba(239, 246, 255, 0.7);\n  color: #2563eb;\n}\n\n.sd-crumb.org {\n  border: 1px solid #d1fae5;\n  background-color: rgba(240, 253, 244, 0.7);\n  color: #059669;\n}\n\n.sd-crumb.type {\n  border: 1px solid #ede9fe;\n  background-color: rgba(245, 243, 255, 0.7);\n  color: #7c3aed;\n}\n\n.sd-crumb.channel {\n  color: #92400e;\n  background: rgba(254, 243, 199, 0.7);\n  border: 1px solid #fde68a;\n}\n\n/* ── Section Panel ─────────────────────────────────────────── */\n.sd-section {\n  display: flex;\n  flex-direction: column;\n}\n\n.sd-section-header {\n  margin-bottom: 16px;\n}\n\n.sd-section-title {\n  font-size: 16px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: #020617;\n  margin: 0;\n}\n\n.sd-section-desc {\n  margin-top: 4px;\n  font-size: 13px;\n  color: #64748b;\n  margin-bottom: 0;\n}\n\n/* ── Grid of Terminals ─────────────────────────────────────── */\n.sd-term-grid {\n  display: grid;\n  gap: 14px;\n  grid-template-columns: 1fr;\n  width: 100%;\n}\n\n@media (min-width: 640px) {\n  .sd-term-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n}\n\n@media (min-width: 1024px) {\n  .sd-term-grid { grid-template-columns: repeat(3, minmax(0, 1fr)); }\n}\n\n/* ── Terminal Card — base ──────────────────────────────────── */\n.sd-term-card {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 16px;\n  border-radius: 22px;\n  border: 1.5px solid #e2e8f0;\n  padding: 20px;\n  text-align: left;\n  transition: all 0.2s ease-in-out;\n  box-sizing: border-box;\n  width: 100%;\n  font-family: inherit;\n}\n\n/* ── Available — clean white, green badge ──────────────────── */\n.sd-term-card.available {\n  cursor: pointer;\n  background: #ffffff;\n  border-color: #e2e8f0;\n}\n\n.sd-term-card.available:hover,\n.sd-term-card.available.sd-kb-focused {\n  border-color: #2a71ff;\n  background: linear-gradient(145deg, #f0f5ff 0%, #ffffff 100%);\n  box-shadow: 0 12px 32px rgba(42, 113, 255, 0.14);\n}\n\n.sd-term-card.available:hover .sd-term-name,\n.sd-term-card.available.sd-kb-focused .sd-term-name {\n  color: #2a71ff;\n}\n\n.sd-term-card.available:hover .sd-term-check-container,\n.sd-term-card.available.sd-kb-focused .sd-term-check-container {\n  background-color: #2a71ff;\n  color: #ffffff;\n}\n\n.sd-term-card.sd-kb-focused {\n  outline: 2px solid #2a71ff;\n  outline-offset: 2px;\n}\n\n/* ── Live — amber/occupied tint ────────────────────────────── */\n.sd-term-card.live {\n  cursor: not-allowed;\n  background: linear-gradient(145deg, #fffbeb 0%, #fef9ee 100%);\n  border-color: #fcd34d;\n}\n\n.sd-term-card.live .sd-term-icon {\n  background: #78350f;\n}\n\n.sd-term-card.live .sd-term-check-container {\n  background: #fef3c7;\n  color: #d97706;\n}\n\n.sd-term-card.live .sd-term-name {\n  color: #92400e;\n}\n\n/* ── Card internals ────────────────────────────────────────── */\n.sd-term-top {\n  display: flex;\n  width: 100%;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.sd-term-icon {\n  display: flex;\n  height: 48px;\n  width: 48px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 14px;\n  background-color: #0b132b;\n  color: #ffffff;\n}\n\n.sd-term-monitor-icon {\n  height: 20px;\n  width: 20px;\n}\n\n.sd-term-check-container {\n  display: flex;\n  height: 28px;\n  width: 28px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 9999px;\n  background-color: #f1f5f9;\n  color: #94a3b8;\n  transition: background-color 0.2s, color 0.2s;\n}\n\n.sd-term-check-icon {\n  height: 16px;\n  width: 16px;\n}\n\n.sd-term-details {\n  width: 100%;\n  margin-top: 8px;\n}\n\n.sd-term-name {\n  font-size: 16px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: #020617;\n  margin: 0;\n  transition: color 0.2s;\n}\n\n.sd-term-badge-wrapper {\n  margin-top: 14px;\n}\n\n/* ── Status badges ─────────────────────────────────────────── */\n.sd-status-badge {\n  display: inline-flex;\n  border-radius: 9999px;\n  padding: 4px 12px;\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.16em;\n}\n\n/* Available — green */\n.sd-status-badge.available {\n  background: #dcfce7;\n  color: #16a34a;\n  border: 1px solid #bbf7d0;\n}\n\n/* Live — amber */\n.sd-status-badge.live {\n  background: #fef3c7;\n  color: #b45309;\n  border: 1px solid #fde68a;\n}\n\n/* ── No Active Day ─────────────────────────────────────────── */\n.sd-section-no-day {\n  border-radius: 24px;\n  border: 1px solid #e2e8f0;\n  background: #ffffff;\n  padding: 32px;\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.04);\n  max-width: 560px;\n  margin: 32px auto;\n  text-align: center;\n  box-sizing: border-box;\n}\n\n.sd-section-no-day .sd-section-header {\n  margin-bottom: 12px;\n  display: flex;\n  justify-content: center;\n}\n\n.sd-section-no-day .sd-start-day-btn {\n  margin: 20px auto 0 auto;\n}\n\n/* ── Loading / Empty ───────────────────────────────────────── */\n.sd-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 48px 0;\n  width: 100%;\n}\n\n.sd-empty-desc {\n  font-size: 14px;\n  color: #64748b;\n  margin: 0;\n}\n\n/* ── Start Day Button ──────────────────────────────────────── */\n.sd-start-day-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 48px;\n  padding: 0 28px;\n  background: #2a71ff;\n  border: none;\n  border-radius: 30px;\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n  box-shadow: 0 4px 14px rgba(42, 113, 255, 0.22);\n}\n\n.sd-start-day-btn:hover:not(:disabled) {\n  background: #1e5ade;\n  box-shadow: 0 6px 18px rgba(42, 113, 255, 0.32);\n}\n\n.sd-start-day-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.sd-section-tag {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  color: #64748b;\n  margin: 0 0 4px 0;\n  text-transform: uppercase;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
